import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  EditProjectPage,
  ProjectStateEnum
} from "./dto";
import { NewProjectsService } from "./service";

interface ProjectState {
  editProjectPage: EditProjectPage;
  // changeStateStatus: PromiseStatuses;
}

const initialState: ProjectState = {
  editProjectPage: EditProjectPage.LIST,
  // changeStateStatus: "idle",
};

// export const editProjectTeamLeader = createAsyncThunk(
//   "projects/editProjectTeamLeader",
//   async (
//     request: { id: string; teamLeaderId: string | null },
//     thunkApi
//   ): Promise<void> => {
//     const ProjectsService = NewProjectsService();

//     return ProjectsService.editProjectTeamLeader(request.id, request.teamLeaderId);
//   }
// );

export const changeStatus = createAsyncThunk(
  "projects/changeStatus",
  async (
    request: {
      state:
      | ProjectStateEnum.CONCLUDED
      | ProjectStateEnum.INPROGRESS
      | undefined;
      id: string;
    }[]
  ): Promise<void> => {
    const ProjectListsService = NewProjectsService();

    return ProjectListsService.changeStatus(request);
  }
);

// export const editProject = createAsyncThunk(
//   "projects/editProject",
//   async (
//     request: { id: string; data: EditProjectRequest },
//     thunkApi
//   ): Promise<void> => {
//     const ProjectsService = NewProjectsService();

//     return ProjectsService.editProject(request.id, request.data);
//   }
// );

// export const editCustomerInProject = createAsyncThunk(
//   "projects/editCustomerInProject",
//   async (request: { id: string, data: ProjectCustomerBindDTO }): Promise<void> => {
//     const ProjectsService = NewProjectsService();

//     return ProjectsService.editCustomerInProject(request.id, request.data);
//   }
// )

const projectsSlice = createSlice({
  name: "projects/slice",
  initialState,
  extraReducers(builder) {
  },
  reducers: {
    setEditProjectPage: (state, action) => {
      state.editProjectPage = action.payload;
    },
  },
});

export const {
  setEditProjectPage,
} = projectsSlice.actions;

export default projectsSlice.reducer;
